import React from 'react';
import styled, { css } from 'react-emotion';
const BadgeWrapper = styled('div') `
  width: 100%;
  height: 100%;
`;
const BadgeStyle = css `
  position: absolute;
  z-index: 1;
`;
const BadgeTopLeftWrapper = styled('div') `
  ${BadgeStyle};
  top: 0px;
  left: 0px;
`;
const BadgeTopRightWrapper = styled('div') `
  ${BadgeStyle};
  top: 0px;
  right: 0px;
`;
const BadgeBottomLeftWrapper = styled('div') `
  ${BadgeStyle};
  bottom: 0px;
  left: 0px;
`;
const BadgeBottomRightWrapper = styled('div') `
  ${BadgeStyle};
  bottom: 0px;
  right: 0px;
`;
const ProductBadgeComponent = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Badge = ({ badge }) => {
    return (React.createElement(ProductBadgeComponent, { className: badge.style },
        React.createElement("span", { className: badge.url &&
                css `
            position: absolute;
            z-index: 1;
          ` }, badge.text),
        badge.url && React.createElement("img", { src: badge.url, alt: badge.name })));
};
const Badges = ({ badges = [] }) => {
    if (badges.length === 0)
        return null;
    const topLeftBadges = badges.filter(badge => badge.location === 'TOP_LEFT');
    const topRightBadges = badges.filter(badge => badge.location === 'TOP_RIGHT');
    const bottomLeftBadges = badges.filter(badge => badge.location === 'BOTTOM_LEFT');
    const bottomRightBadges = badges.filter(badge => badge.location === 'BOTTOM_RIGHT');
    return (React.createElement(BadgeWrapper, null,
        topLeftBadges.length > 0 && (React.createElement(BadgeTopLeftWrapper, null, topLeftBadges.map(badge => (React.createElement(Badge, { key: badge.name, badge: badge }))))),
        topRightBadges.length > 0 && (React.createElement(BadgeTopRightWrapper, null, topRightBadges.map(badge => (React.createElement(Badge, { key: badge.name, badge: badge }))))),
        bottomLeftBadges.length > 0 && (React.createElement(BadgeBottomLeftWrapper, null, bottomLeftBadges.map(badge => (React.createElement(Badge, { key: badge.name, badge: badge }))))),
        bottomRightBadges.length > 0 && (React.createElement(BadgeBottomRightWrapper, null, bottomRightBadges.map(badge => (React.createElement(Badge, { key: badge.name, badge: badge })))))));
};
export default Badges;
//# sourceMappingURL=Badges.js.map